import request from '@/utils/axios'
import { ContentTypeEnum } from '@/enums/axios'

const jsonHeaderConfig = {
  headers: {
    'Content-Type': ContentTypeEnum.JSON
  }
}
// 账单列表
export const getBillList = (data: any) =>
  request.post('/erp/bill/page_list', data, jsonHeaderConfig)

// 账单列表-详情
export const getBillDetail = (data: any) => request.post('/erp/bill/details', data)

// 账单列表-账单状态汇总
export const getBillState = () => request.post('/erp/bill/bill_status_summary', null)

// 账单列表-合计 申请提款金额、放款金额
export const getBillTotal = (data: any) =>
  request.post('/erp/bill/total_amount', data, jsonHeaderConfig)

// 账单列表-债权转让
export const transferBill = (data: any) =>
  request.post('/erp/bill/transfer_credit', data, jsonHeaderConfig)

// 账单列表-担保方列表
export const getGuarantor = (data: any) => request.post('/erp/bill/guarantor_list', data)

// 账单列表-提前还款
export const h5DoDrawing = (data: any) =>
  request.post('/erp/web/youka/retail_loan/h5DoDrawing', data, jsonHeaderConfig)

// 发送结清证明
export const sendSettleContract = (data: any) => request.get('/erp/bill/sendSettleContract', data)

// 查合同
export const getContactByBillId = (data: any) =>
  request.post('/erp/retailContractManage/queryByBillId', data, jsonHeaderConfig)

// 获取账单审批信息
export const getBillApproveInfo = (data: any) =>
  request.post('/erp/bill/getBillApproveInfo', data, {
    headers: {
      'Content-Type': ContentTypeEnum.FORM_DATA
    }
  })

// 获取审批状态数量
export const getBillApproveCount = () => request.post('/erp/bill/erp/approveStatusCount', null)

// 设置五级分类
export const setFiveClass = (data: any) =>
  request.post('/erp/bill/updateLevelFive', data, jsonHeaderConfig)
